import React from 'react';
import { Grid } from '@material-ui/core';
import ExhibitCard from './exhibitCard';
import { ExhibitDto } from '../../../../exhibits/exhibits.dtos';
import { GroupScansDto } from '../../../groupVisits.dtos';

interface IProps {
  exhibits: GroupScansDto[];
}

const ExhibitList: React.FC<IProps> = ({ exhibits }) => {
  return (
    <Grid container>
      {exhibits.map((e) => (
        <ExhibitCard exhibit={e.exhibit} />
      ))}
    </Grid>
  );
};

export default ExhibitList;
